import * as Yup from 'yup';

const CollectionSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  description: Yup.string().max(256),
  group_access: Yup.boolean(),
});

export default CollectionSchema;
